export const transformTextListFromEntryDataValue = (
  value: { text: string; is_modified: boolean }[],
) => {
  return value.map((item) => item.text.replace("(etc)", ""));
};
